import { useFormContext } from 'react-hook-form';
import { Text } from '@consumidor-positivo/aurora';
import { SelectOptions } from '../../../components/SelectOptions';

import '../styles.scss';

export const BenefitsStep = () => {
  const { setValue } = useFormContext();

  const benefits = [
    { id: 'miles', label: 'Quero juntar pontos/milhas para viajar' },
    { id: 'cashback', label: 'Quero cashback em minhas compras ou fatura' },
    { id: 'both', label: 'Não tenho preferência, quero ver cartão com cashback e milhas' },
  ];

  return (
    <div className="mm-form__step">
      <div className=" mm-form__step--annuity">
        <div>
          <Text as="p" variant="body-small" weight="semibold" color="secondary" style={{ marginBottom: '8px' }}>
            Agora, conta pra gente...
          </Text>
          <Text as="h2" variant="heading-small" variantDesk="heading-medium" weight="bold">
            O que você está buscando em seu cartão ideal?
          </Text>
        </div>
        <SelectOptions htmlType="submit" options={benefits} onSelect={(option) => setValue('benefit', option.id)} />
      </div>
    </div>
  );
};
